import { __rest, __assign } from 'tslib';
import React, { useRef, useEffect, useCallback } from 'react';
import { ResizeObserver } from '@juggle/resize-observer';
import cn from 'classnames';
import { KeyboardFocusable } from '../../../../keyboard-focusable/esm';
import { fnUtils } from '../../../../shared/esm';
import { useTabs } from '../../hooks/use-tabs.js';
import { ScrollableContainer } from '../scrollable-container/Component.js';
import { Title } from '../title/Component.js';
import 'react-merge-refs';
import 'compute-scroll-into-view';
import '../scroll-controls/Component.js';
import 'lodash/debounce';
import '../../../../icon-button/esm';
import '@alfalab/icons-glyph/ChevronLeftCompactSIcon';
import '@alfalab/icons-glyph/ChevronRightCompactSIcon';
import '../scroll-controls/utils.js';
import '../../../../skeleton/esm';

var PrimaryTabList = function (_a) {
    var size = _a.size, _b = _a.styles, styles = _b === void 0 ? {} : _b, className = _a.className, containerClassName = _a.containerClassName, _c = _a.titles, titles = _c === void 0 ? [] : _c, _d = _a.selectedId, selectedId = _d === void 0 ? titles.length ? titles[0].id : undefined : _d, _e = _a.scrollable, scrollable = _e === void 0 ? true : _e, fullWidthScroll = _a.fullWidthScroll, onChange = _a.onChange, dataTestId = _a.dataTestId, platform = _a.platform, textStyle = _a.textStyle, inlineStyle = _a.inlineStyle, showSkeleton = _a.showSkeleton, skeletonProps = _a.skeletonProps;
    var lineRef = useRef(null);
    var _f = useTabs({
        titles: titles,
        selectedId: selectedId,
        onChange: onChange,
    }), selectedTab = _f.selectedTab, focusedTab = _f.focusedTab, getTabListItemProps = _f.getTabListItemProps;
    // расчет размера и положения нижней полосы
    useEffect(function () {
        if (selectedTab) {
            var updateLineWidth = function () {
                if (lineRef.current) {
                    lineRef.current.style.width = "".concat(selectedTab.offsetWidth, "px");
                    lineRef.current.style.transform = "translateX(".concat(selectedTab.offsetLeft, "px)");
                }
            };
            var ResizeObserver_1 = window.ResizeObserver || ResizeObserver;
            var observer_1 = new ResizeObserver_1(updateLineWidth);
            observer_1.observe(selectedTab);
            return function () { return observer_1.disconnect(); };
        }
        return fnUtils.noop;
    }, [selectedTab, titles]);
    var handleTitleResize = useCallback(function () {
        if (selectedTab && lineRef.current) {
            lineRef.current.style.width = "".concat(selectedTab.offsetWidth, "px");
            lineRef.current.style.transform = "translateX(".concat(selectedTab.offsetLeft, "px)");
        }
    }, [selectedTab]);
    var renderContent = function () {
        var _a;
        return (React.createElement("div", { role: 'tablist', "data-test-id": dataTestId, className: cn(styles.component, className, !textStyle && size && styles[size], (_a = {},
                _a[styles.fullWidthScroll] = fullWidthScroll,
                _a)) },
            titles.map(function (_a, index) {
                _a.dataTestId; _a.toggleRef; var restTitleProps = __rest(_a, ["dataTestId", "toggleRef"]);
                return (React.createElement(KeyboardFocusable, { key: restTitleProps.id }, function (ref, focused) { return (React.createElement(Title, __assign({}, getTabListItemProps(index, ref), restTitleProps, { focused: focused, styles: styles, showSkeleton: showSkeleton, skeletonProps: skeletonProps, onResize: handleTitleResize }))); }));
            }),
            React.createElement("div", { className: styles.line, ref: lineRef })));
    };
    var wrapperClassName = cn(textStyle && styles[textStyle], styles[platform]);
    return scrollable ? (React.createElement(ScrollableContainer, { containerWrapperClassName: wrapperClassName, activeChild: focusedTab || selectedTab, containerClassName: containerClassName, scrollControlsClassName: cn(textStyle && styles.scrollControls), fullWidthScroll: fullWidthScroll, view: 'primary', size: textStyle ? undefined : size, platform: platform, inlineStyle: inlineStyle, showSkeleton: showSkeleton }, renderContent())) : (React.createElement("div", { className: cn(styles.container, wrapperClassName, containerClassName), style: inlineStyle }, renderContent()));
};

export { PrimaryTabList };
